import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";

import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { HistoryService } from "../../../services/history.service";

import { History } from "../../../models/history.model";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogHistoryComponent } from "../../dialog-history/dialog-history.component";
import { UserService } from "../../../@core/services/user.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "ngx-view-history",
  styleUrls: ["./view-history.component.scss"],
  templateUrl: "./view-history.component.html",
})
export class ViewHistoryComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() mode?: string = ""; //admin / develop
  @Input() history: History;
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "main";
  uid = "";

  constructor(
    public userService: UserService,
    private historyService: HistoryService,
    private dialogService: NbDialogService,
    private router: Router
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  reply() {
    this.view = "replies";
  }

  closeReply() {
    this.view = "main";
  }

  loadContent(value) {
    this.isMore = value;
  }

  navigateRef(item) {
    if (item.navigateUrl != "") {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.historyService
            .delete(this.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.onDelete.emit(item.id);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  edit(item: History) {
    let lecBk = new History();
    lecBk = clone(item);
    this.dialogService
      .open(DialogHistoryComponent, {
        context: {
          header: "Cập nhật bài viết",
          mode: "edit",
          history: lecBk,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.history = value;
          this.onEdit.emit(value);
        }
      });
  }

  createHistory(item) {
    //
  }

  viewHistory(item) {
    //
  }

  viewProfile(userId) {
    const value = !this.isMore;
    this.loadContent(value);
    // this.dialogService.open(DialogProfileComponent, {
    //   context: {
    //     header: "Thông tin tài khoản",
    //     userId: userId,
    //   },
    //   closeOnBackdropClick: false,
    // });
  }
}
